/* RESPONSIBLE TEAM: team-actions */
import AppstoreAppPackageController from 'embercom/controllers/base/appstore/app-package';

export default AppstoreAppPackageController;
